'use strict';

var React = require('react');

var SvgFolderIcon = function SvgFolderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.75 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h8.5c.69 0 1.25-.56 1.25-1.25v-4.5c0-.69-.56-1.25-1.25-1.25h-3.382a1.75 1.75 0 0 1-1.565-.967l-.171-.342a1.25 1.25 0 0 0-1.118-.691h-2.264Zm-2.75 1.25a2.75 2.75 0 0 1 2.75-2.75h2.264a2.75 2.75 0 0 1 2.46 1.52l.17.342a.25.25 0 0 0 .224.138h3.382a2.75 2.75 0 0 1 2.75 2.75v4.5a2.75 2.75 0 0 1-2.75 2.75h-8.5a2.75 2.75 0 0 1-2.75-2.75v-6.5Z"
  }));
};
SvgFolderIcon.displayName = "FolderIcon";

exports.SvgFolderIcon = SvgFolderIcon;
